"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Steps = exports.StepIndex = void 0;
var STEP_1 = 'step1';
var STEP_2 = 'step2';
var STEP_3 = 'step3';
var STEP_4 = 'step4';
var STEP_5 = 'step5';
var STEP_6 = 'step6';

// Step indices according to Step Definitions
var youAndYourPets = 'step1';
var coverOptions = 'step2';
var yourDetails = 'step3';
var summary = 'step4';
var payment = 'step5';
var success = 'step6';
var Steps = exports.Steps = {
  STEP_1: STEP_1,
  STEP_2: STEP_2,
  STEP_3: STEP_3,
  STEP_4: STEP_4,
  STEP_5: STEP_5,
  STEP_6: STEP_6
};
var StepIndex = exports.StepIndex = {
  youAndYourPets: youAndYourPets,
  coverOptions: coverOptions,
  yourDetails: yourDetails,
  summary: summary,
  payment: payment,
  success: success
};